import {
  API_LOAN_DOWNLOAD_PARTY,
  API_LOAN_GET_BORROWER_REQUIRED_PARTIES,
  API_LOAN_GET_PARTY_IDS,
  API_LOAN_IMPORT_PARTY,
  API_LOAN_PARTY,
  API_LOAN_PARTY_ADDITIONAL_INFO,
  API_LOAN_PARTY_AI_EXTRACT,
  API_LOAN_PARTY_BY_LOANNUMBER,
  API_LOAN_PARTY_LOG,
  API_LOAN_PARTY_OPTIONS,
  API_LOAN_UPDATE_PARTIES,
} from 'config'
import Api from 'services/api'

import { downloadFile } from '../documents'

export const updateParty = (data: any) => {
  return Api.put(API_LOAN_PARTY, data)
}

export const getPartyOptions = (key: string) => {
  return Api.get(API_LOAN_PARTY_OPTIONS, {}, { key })
}

export const getParties = (loanNumber: number, isPool: boolean = false) => {
  return Api.get(API_LOAN_PARTY_BY_LOANNUMBER, { isPool }, { loanNumber })
}

export const getPartyAdditionalInfo = (type: string) => {
  return Api.get(API_LOAN_PARTY_ADDITIONAL_INFO, {}, { type })
}

export const updateParties = (
  loanNumber: number,
  PartyID: number,
  data: Record<string, any>,
  isPool: boolean = false,
) => {
  return Api.put(API_LOAN_UPDATE_PARTIES, { data, isPool }, { loanNumber, PartyID }, { timeout: 150000 })
}

export const addParty = (loanNumber: number, type: string, isPool: boolean = false) => {
  return Api.post(API_LOAN_PARTY_BY_LOANNUMBER, { type, isPool }, { loanNumber })
}

export const deleteParty = (loanNumber: number, type: string, isPool: boolean = false) => {
  return Api.delete(API_LOAN_PARTY_BY_LOANNUMBER, { type, isPool }, { loanNumber })
}

export const getPartyIds = () => {
  return Api.get(API_LOAN_GET_PARTY_IDS)
}

export const getBorrowerRequiredParties = () => {
  return Api.get(API_LOAN_GET_BORROWER_REQUIRED_PARTIES)
}

export const getPartyLogs = (loanNumber: number, field: string, partyName: string) => {
  return Api.get(API_LOAN_PARTY_LOG, {}, { loanNumber, field, partyName })
}

export const downloadParties = async (loanNumber: number, isSample: boolean = false, isRolodex: boolean = false) => {
  const res: Blob = await Api.get(
    API_LOAN_DOWNLOAD_PARTY,
    { isSample },
    { loanNumber },
    {
      responseType: 'blob',
    },
  )
  downloadFile(`${isRolodex ? 'Rolodex' : 'Parties'} - ${isSample ? 'Sample' : loanNumber}.csv`, res)
}

export const importParties = (loanNumber: number, data: Record<string, any>[], isPool: boolean = false) => {
  return Api.post(API_LOAN_IMPORT_PARTY, { data, isPool }, { loanNumber })
}

export type PartyAiExtractData = Record<string, string | null>

export const extractPartyFromPdf = (
  partyType: string,
  files: Array<{ fileKey: string; name: string }>,
): Promise<{ success: boolean; message?: string; data?: PartyAiExtractData | null }> => {
  return Api.post(API_LOAN_PARTY_AI_EXTRACT, { files, partyType }, {}, { timeout: 0 })
}
